import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import ConditionalBaseBox from "../layout/ConditionalBaseBox";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(BoxTypes.DayOfWeekConditional, data);
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <ConditionalBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.DayOfWeekConditional, data)}
      title={BoxTitles.DayOfWeekConditional}
      isConnectable={isConnectable}
    >
      {subline()}
    </ConditionalBaseBox>
  );
});
